import { isProductionBzDomain, runningClientSide } from '@benzinga/utils';

const PRODUCTION_IFRAME_BASE = 'https://www.benzinga.com/premium/ideas/e-iframe/';
const STAGING_IFRAME_BASE = 'https://bz.zingbot.bz/premium/ideas/staging-checkout-2/';

export type EdgeIframeCheckoutParams = {
  ad: string;
  adType?: string;
  campaign: string;
};

export const buildEdgeIframeCheckoutUrl = (params: EdgeIframeCheckoutParams): string => {
  const { ad, adType = 'paywall', campaign } = params;

  const useProduction = !runningClientSide() || isProductionBzDomain();
  const baseUrl = useProduction ? PRODUCTION_IFRAME_BASE : STAGING_IFRAME_BASE;

  const urlParams = new URLSearchParams({
    utm_ad: ad,
    utm_adType: adType,
    utm_campaign: campaign,
  });

  return `${baseUrl}?${urlParams.toString()}`;
};
